
<template>
  <b-modal
    id="confirm-save-internal-movement-modal"
    ref="modal"
    header-class="headerModal"
    centered
    :scrollable="false"
    size="s"
    :title="`${$t('ConfirmSaveFor')}: ${getOrderMovementDetails?.orderMovementNumber}`"
    hide-footer
    @hide="onCancel"
  >
    <div>
      <span
        style="color: #262E6C; font-weight: bold;"
      >
        {{ orderMovementState === 'PrepareInTransit' ?
          `${$t('AreUSureUWantToStartDelivering')} ${getOrderMovementDetails?.receiverStoreName}`
          : `${$t('AreUSureUWantToAcceptDelivery')} ${getOrderMovementDetails?.deliverStoreName}` }}?
      </span>
      <vue-select
        v-if="orderMovementState === 'InTransit'"
        v-model="selectedTeamId"
        :options="getDropdownTeamName"
        :placeholder="$t('SelectTeam')"
        label="teamName"
        :reduce="(e) => e.teamNameId"
        aria-describedby="input-1-live-feedback"
        required
        style="margin-top: 30px"
      />
    </div>
    <div class="buttonsEverywhere">
      <button
        v-if="orderMovementState === 'PrepareInTransit'"
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        @click="updateOrder"
      >
        <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <button
        v-else
        type="button"
        variant="none"
        style="margin-left: 0px;"
        class="buttonSubmit"
        @click="receiveFromOtherStore"
      >
        <div
          v-if="loading"
          style="width:100%"
          class="pdf-spinner-overlay"
        >
          <span class="loader" />
        </div>
        {{ $t('Submit') }}
      </button>
      <b-button
        type="reset"
        variant="danger"
        class="buttonCancel"
        style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
        @click="onCancel"
      >
        {{ $t('Cancel') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['clickedOrderMovementId', 'orderMovementState'],
  data() {
    return {
      loading: false,
      selectedTeamId: null,
    }
  },
  mounted() {
    this.dropdown_TeamNames(50)
  },
  computed: {
    ...mapGetters(['getOrderMovementDetails', 'getDropdownTeamName']),
  },
  methods: {
    ...mapActions(['loadUpdateStateByOrderMovement', 'dropdown_TeamNames', 'loadReceiveOrderFromOtherStore']),
    async receiveFromOtherStore() {
      if (!this.selectedTeamId) return

      const data = {
        orderMovementId: this.clickedOrderMovementId,
        teamNameId: this.selectedTeamId,
      }

      try {
        this.loading = true
        await this.loadReceiveOrderFromOtherStore({
          object: data,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.$emit('updateListOnClose');
            this.$emit('updateMovementsDetail');
          },
        })
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    async updateOrder() {
      try {
        this.loading = true
        let stateMovement
        if (this.orderMovementState === 'PrepareInTransit') {
          stateMovement = 'InTransit'
        } else {
          stateMovement = 'Accepted'
        }
        await this.loadUpdateStateByOrderMovement({
          orderMovementId: this.clickedOrderMovementId,
          newOrderMovementState: stateMovement,
          successCallback: () => {
            this.loading = false
            this.$refs.modal.hide();
            this.onReset();
            this.$emit('updateListOnClose');
            this.$emit('updateMovementsDetail');
          },
        });
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    onCancel() {
      this.onReset();
    },
    onReset() {
      this.loading = false
      this.$refs.modal.hide();
    },
  },
}
</script>

<style scoped lang="scss">
</style>
